function useResourceEventBus<T = any>(resourceName: string) {
  const { emit, off, on, once, reset } = useEventBus<
    "CREATED" | "UPDATED" | "DELETED" | "REFRESH",
    T
  >(resourceName);

  const emitResourceEvent = (
    action: "CREATED" | "UPDATED" | "DELETED" | "REFRESH",
    data?: T
  ) => {
    emit(`${action}`, data);
  };

  return {
    emit: emitResourceEvent,
    off,
    on,
    once,
    reset
  };
}

export { useResourceEventBus };
